import { render, staticRenderFns } from "./PageAbout.vue?vue&type=template&id=d3186744&scoped=true"
import script from "./PageAbout.vue?vue&type=script&lang=js"
export * from "./PageAbout.vue?vue&type=script&lang=js"
import style0 from "./PageAbout.vue?vue&type=style&index=0&id=d3186744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3186744",
  null
  
)

export default component.exports